<template>
    <div class="modal-overlay">
        <div class="modal-content">
            <h3 class="text-2xl font-bold mb-4 flex items-center">
                <font-awesome-icon :icon="['fas', 'info-circle']" class="text-blue-500 mr-2" />
                {{ $translate('incomplete_account_information') }}
            </h3>
            <p class="text-gray-600 mb-4">
                {{ $translate('account_missing_information_message') }}
            </p>
            <div class="flex justify-end">
                <button type="button" @click="goToSettings"
                    class="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline">
                    {{ $translate('go_to_settings') }}
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import { useRouter } from 'vue-router';
import { getSystemPath } from '@/utils/helper';

export default {
    name: 'MissingInfoModal',
    setup() {
        const router = useRouter();

        const goToSettings = () => {
            router.push({
                path: `/${getSystemPath('account')}/${getSystemPath('settings')}`,
            });
        };

        return {
            goToSettings,
        };
    },
};
</script>

<style scoped>
.modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.6);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
}

.modal-content {
    background-color: #fff;
    padding: 1.5rem;
    border-radius: 0.5rem;
    max-width: 500px;
    width: 100%;
}
</style>